import styled from 'styled-components';
import type { FlattenSimpleInterpolation } from 'styled-components';

interface StyledGridProps {
    $layoutCss?: Array<FlattenSimpleInterpolation | string>;
}

export const StyledGrid = styled.div<StyledGridProps>`
    box-sizing: border-box;
    ${({ $layoutCss }) => $layoutCss}
`;
